import { createFileRoute, Outlet } from '@tanstack/react-router'
import { signInWithRedirect } from 'aws-amplify/auth'

import { authProviderAtom, authStore } from '@/features/auth/atoms'
import { fetchAuthSession, isMock, signOut } from '@/libs/auth/amplify'

export const Route = createFileRoute('/_public/login/cognito')({
  beforeLoad: async () => {
    authStore.set(authProviderAtom, 'COGNITO')

    if (isMock) {
      // 開発用 mock は signInWithRedirect を行わず常に有効なセッションを返すため、
      // SPA 遷移のままだと AuthProvider が me を再取得せずログイン画面で止まる。
      // 本番 callback と同様にフルリロードして COGNITO で認証フローを再初期化する。
      location.replace('/')
      return
    }

    const session = await fetchAuthSession()
    if (session?.tokens) {
      // トークンが残っているとsignInWithRedirectでエラーになるので消しておく
      await signOut()
      // Managed Login のサインアウトを開始したら、同一フローで signInWithRedirect() を呼ばない。
      // サインアウトとサインインが競合して無限ループするため、ここで処理を終了する。
      // Managed Login のサインアウト成功後は、リダイレクトでこの処理に戻ってくるので、そこで改めて signInWithRedirect() を呼ぶ。
      return
    }
    signInWithRedirect({
      options: {
        lang: 'ja'
      }
    })
  },
  component: () => <Outlet />
})
